import {Injectable, isDevMode} from '@angular/core';
import {IStepOption as IMdStepOption, TourService} from 'ngx-ui-tour-md-menu';
import {Router} from '@angular/router';
import {AppRoutes, AppRoutesAccount} from '../../../guards/app-routes';
import {UserDetailService} from 'src/app/services/user-detail.service';
import {TOUR_TABS} from '../../home/components/account-setup-wizard/tour-steps';
import {AuthService, UserRole} from '../../../services/auth.service';
import {SettingService, TenantSettingApiModel, TenantSettingKey} from '../../../../api-new';
import {NbToastrService} from '@nebular/theme';

export interface IAccountSetupData {
  id: string;
  name: string;
  tour?: IMdStepOption[];
}

enum TourState {
  OFF,
  ON,
  PAUSED
}

@Injectable({ providedIn: 'root' })
export class AccountSetupWizardService {
  public tourProgress = 0;
  public done = false;
  role?: UserRole;

  constructor(
    private router: Router,
    readonly tour: TourService,
    private toast: NbToastrService,
    private userDetail: UserDetailService,
    private settingService: SettingService,
    private auth: AuthService,
  ) {
    this.tour.setDefaults({
      disableScrollToAnchor: true,
      duplicateAnchorHandling: 'registerFirst',
      delayBeforeStepShow: 500,
      enableBackdrop: true,
      prevBtnTitle: 'Predch.',
      nextBtnTitle: 'Nasl.',
      endBtnTitle: 'Koniec prezentácie',
      backdropConfig: { offset: 10, backgroundColor: 'rgba(0, 0, 0, 0.2)' },
    });

    this.userDetail.settingsUpdated$.subscribe(() => this.applySettings());
  }

  private applySettings() {
    this.role = this.userDetail.role;
    const onboardingProgress = this.userDetail.getTenantSetting(TenantSettingKey.ONBOARDING_PROGRESS);


    if (onboardingProgress === '0') {
      this.done = false;
      this.tourProgress = 0;
      if (isDevMode()) {
        const safeRoute = this.router.url;
        if (safeRoute.includes(AppRoutesAccount.CONTACT_US)) {
          return;
        } else {
          this.safeNavToPricePlan();
          return;
        }
      }
    }


    if (onboardingProgress === 'done') {
      this.tourProgress = TOUR_TABS.length;
      this.done = true;
    } else {
      this.done = false;
      this.tourProgress = +(onboardingProgress ?? '1');
    }
    // as tarif plan is hiden in prod now we skip 1. part
    if (!isDevMode() && this.tourProgress === 0) {
      this.tourProgress = 1
    }

    if (this.role === UserRole.human_resource_manager && !this.done && onboardingProgress !== '0') {
      this.startTour();
    }
  }

  private safeNavToPricePlan() {
    const target = `/${AppRoutes.REGISTER}/${AppRoutesAccount.PRICE_PLAN}`;

    this.router.navigate([target]);
  }

  startTour(setProgressDEV?: number) {
    if (this.role! !== UserRole.human_resource_manager) return;
    if (setProgressDEV) this.tourProgress = setProgressDEV;

    this.tour.initialize(TOUR_TABS[this.tourProgress].tour!);
    this.tour.start();
  }

  cancelTour() {
    if (this.tourIsRunning()) {
      this.tour.end();
    }
  }

  finishTourByLastStep() {
    if (!this.tourIsRunning()) {return;}

    this.tour.end();
    this.tourProgress += 1;

    const payload: TenantSettingApiModel = {
      key: 'ONBOARDING_PROGRESS',
      value: this.tourProgress == 6 ? 'done' : this.tourProgress + '',
    };

    this.settingService.settingUpdateTenantSetting(+this.userDetail.tenantId!, payload).subscribe({
      next: () => {
        this.userDetail.refreshSettings().subscribe();
      },
      error: err => {
        this.toast.danger(`Nepodarilo sa načítať menu ${err.message}`);
      }
    });

    if (this.tourProgress == 6) this.done = true;
    this.router.navigateByUrl('/' + AppRoutes.HOME);


    if (this.tourProgress <= TOUR_TABS.length) {
      this.startTour();
    }
  }

  nextStep() {
    if (this.tourIsRunning()) this.tour.next();
  }

  backStep(tourStepId?: string) {
    if (!this.tourIsRunning()) return;
    if (tourStepId) this.tour.goto(tourStepId);
    else this.tour.prev();
  }

  private tourIsRunning(): boolean {
    return this.tour.getStatus() == TourState.ON;
  }

}
